import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    Modal,
    Input,
    Checkbox,
    Divider,
    Row,
    Col,
    Select,
    Form
} from "antd";
import { List ,Map} from "immutable";
import {
    requestDocuments,
    fetchDocumentTypes
} from "store/actions";
import { STATE_STATUS } from "constants/index";

const {TextArea} = Input;
const FormItem = Form.Item;


const applicantDocuments = {
    7 : "Pan Card",
    6 : "Photograph",
    63 : "Aadhar Card M",
}

const applicantAadharBoth = {
    '63-12' : "Aadhar - Front",
    '63-13' : "Aadhar - Back"
} 

const otherDocuments = {
    46 : "Others"
}
class DocumentRequestModal extends React.Component {
    state = {
        requestedDocs: [],
        applicantSelectModal : false,
        requestedApplicantDocs : [],
        document : [],
        filteredAadharBoth : [],
        filterOtherDocuments : []
    };

    async handleFetchDocumentMasterList() {
        if(this.props.isOnboardingCase){
            if (this.props.companyDocMasterListStatus == STATE_STATUS.UNFETCHED) {
                this.props.fetchDocumentTypes(this.props.companyId);
            }
        }else{
            if (this.props.docMasterListStatus == STATE_STATUS.UNFETCHED) {
                this.props.fetchDocumentTypes();
            }
        }
       
    }

    componentDidMount() {
        this.handleFetchDocumentMasterList();
    }

    requestDocSearch = (event) => {
        console.log(event);
    }

    filterDocumentCategory = (doc) => {
        return this.state.requestDocSearchQuery ? doc.document_name && doc.document_name.toLocaleLowerCase().includes(this.state.requestDocSearchQuery.toLocaleLowerCase()) : true;
    }

    onChangeRequestDocs=(val) => {
        this.setState({
            requestedDocs: val
        });
    };

    requestDocumentsHandler=() => {
        let filteredApplicantDocs = this.state.requestedDocs.filter(_ => applicantDocuments[_]);
        let filteredAadharBoth = this.state.requestedDocs.filter(_ => applicantAadharBoth[_])
        let filterOtherDocuments = this.state.requestedDocs.filter(_ => otherDocuments[_])
        if(filteredApplicantDocs.length > 0 || filteredAadharBoth.length > 0){
            this.setState({
                applicantSelectModal : true,
                requestedApplicantDocs : filteredApplicantDocs,
                filteredAadharBoth : filteredAadharBoth,
                filterOtherDocuments : filterOtherDocuments
            })
        }else if(filterOtherDocuments.length > 0){
            this.setState({
                filterOtherDocuments : filterOtherDocuments,
                applicantSelectModal : true,
            })
        }else{
            const newDocs=Object.assign([],this.state.requestedDocs);
            this.setState(
                {
                    requestedDocs: []
                },
                () => {
                    this.props.requestDocuments(
                        this.props.caseId,
                        this.props.companyId,
                        newDocs
                    );
                }
            );
            this.props.requestDocumentsHandler();
        }
    };


    handleApplicantSelectModal=() => {
        this.setState({
            document : [],
            requestedDocs : [],
            requestedApplicantDocs  : [],
            filteredAadharBoth : [],
            filterOtherDocuments : [],
            applicantSelectModal : !this.state.applicantSelectModal
        })
    }


    requestApplicantDocumentsHandler = () => {
        const allRequestedDocs = [...this.state.requestedDocs];
        let documents_associate = this.state.document.map(_ => {
            if(_.id.toString().includes('-')){
                _.document_option_id =  parseInt(_.id.split('-')[1]);
                _.id = parseInt(_.id.split('-')[0]);
            }else{
                _
            }
            return _;
        });
        this.setState({
            requestModal : false,
            requestedApplicantDocs : [],
        } , () => {
            let data = {
                document : documents_associate,
                documents : allRequestedDocs.filter(_ => !applicantDocuments[_] && !applicantAadharBoth[_] && !otherDocuments[_])
            }
            this.props.requestDocuments(
                this.props.caseId,
                this.props.companyId,
                data,
                true
            );
            this.handleApplicantSelectModal();
            this.props.requestDocumentsHandler();
            this.setState({
                document : [],
                requestedDocs : [],
            })
        })
    }

    onSelectApplicantForRequestedDoc = (docId, associate,docRemarks = '') => {
        let alreadyAdded = this.state.document.find(_ => _.id == docId);
        if(alreadyAdded && alreadyAdded.id){
            this.setState({
                document : this.state.document.filter(_ => _.id != docId)} , () => {
                    this.setState({
                        document : [...this.state.document , {
                            id : docId,
                            associate : associate ? associate : undefined,
                            request_remarks : docRemarks ? docRemarks : undefined      
                        }]
                    })
                })
        }else{
            this.setState({
                document : [...this.state.document , {
                    id : docId,
                    associate : associate ? associate : undefined,
                    request_remarks : docRemarks ? docRemarks : undefined
                }]
            })
        }
    }


    selectApplicantModal = () => {
        const {requestedApplicantDocs , filteredAadharBoth, filterOtherDocuments} = this.state;
        const filteredRequestRemarks = this.state.document.filter(_ => _.request_remarks != null && _.request_remarks != "");
        let associates   = this.props.companyAssociates.size ? this.props.companyAssociates : this.props.associates;
        return <Modal
        visible={this.state.applicantSelectModal}
        onCancel={this.handleApplicantSelectModal}
        title={"Select Applicant/Document Name"}
        destroyOnClose
        onOk={this.requestApplicantDocumentsHandler}
        className={"doc-checkboxes"}
        width={"40vw"}
        height={"80vh"}
        okButtonProps={{ disabled: filteredRequestRemarks.some(_ => _.request_remarks.length < 5 ) }}
        bodyStyle={{
            maxHeight: "500px",
            overflowY: "scroll"
        }}>
        {requestedApplicantDocs.length ? requestedApplicantDocs.map(_ => <Col span={24} style={{
            paddingTop: "2px",
            paddingBottom: "2px"
        }} className={"d-flex justify-content-space-between"}>
            <p>{applicantDocuments[_]}</p>
            <Select
                className={"fb-50"}
                style={{
                    minWidth: "200px"
                }}
                size={"small"}
                dropdownMatchSelectWidth={false}
                onChange={(val) => this.onSelectApplicantForRequestedDoc(_ , val , '')}
                >
                {associates && (associates.length || associates.size) && associates.map((_, k) => (
                    <Select.Option key={k} value={_ && _.id}>
                        {`${_ && _.first_name} ${_ && _.last_name}`}
                    </Select.Option> 
                )).toList()}
            </Select>
        </Col>) : <div></div>}
        {filteredAadharBoth.length ? filteredAadharBoth.map((_ , key) => <Col key={key} span={24} style={{
            paddingTop: "2px",
            paddingBottom: "2px"
        }} className={"d-flex justify-content-space-between"}>
            <p>{applicantAadharBoth[_]}</p>
            <Select
                className={"fb-50"}
                style={{
                    minWidth: "200px"
                }}
                size={"small"}
                dropdownMatchSelectWidth={false}
                onChange={(val) => this.onSelectApplicantForRequestedDoc(_ , val , '')}
                >
                {associates && (associates.length  ||  associates.size) && associates.map((_, k) => (
                    <Select.Option key={k} value={_ && _.id}>
                        {`${_ && _.first_name} ${_ && _.last_name}`}
                    </Select.Option> 
                )).toList()}
            </Select>
        </Col>) : <div></div>}
        {filterOtherDocuments.map((_ , key) => <Col key={key} span={24} style={{
                paddingTop: "2px",
                paddingBottom: "2px"
            }} className={"d-flex justify-content-space-between"}>
                <p>{otherDocuments[_]}</p>
                <FormItem help={filteredRequestRemarks.some(_ => _.request_remarks.length < 5 ) ? "Minimum Characters should be 5" : ""}>
                    <TextArea 
                        rows={2}
                        placeholder="Enter document name"
                        onChange={(e) =>this.onSelectApplicantForRequestedDoc(_ , '', e.target.value)}
                        className={"fb-50"}
                        minLength={5}
                        style={{
                            minWidth: "200px"
                        }}/>
                </FormItem>
            </Col>)}
    </Modal>
    }


    render() {
        this.groupedDocMasterList = null;
        if(this.props.isOnboardingCase){
            this.groupedDocMasterList =
            this.props.companyDocMasterList &&
            this.props.companyDocMasterList.length &&
            new List(this.props.companyDocMasterList).groupBy(
                item => item.document_category && item.document_category.name
            ).map(_ => _.filter(this.filterDocumentCategory))
                .filter(_ => _.size > 0);

        }else{
            this.groupedDocMasterList =
            this.props.docMasterList &&
            this.props.docMasterList.length &&
            new List(this.props.docMasterList).groupBy(
                item => item.document_category && item.document_category.name
            ).map(_ => _.filter(this.filterDocumentCategory))
                .filter(_ => _.size > 0);
        }

        return (
            <React.Fragment>
                {this.selectApplicantModal()}
                <Modal
                    visible={this.props.requestModal}
                    onCancel={this.props.closeRequestModal}
                    title={"Request Documents"}
                    destroyOnClose
                    onOk={() => this.requestDocumentsHandler()}
                    className={"doc-checkboxes"}
                    width={"40vw"}
                    height={"80vh"}
                    bodyStyle={{
                        maxHeight: "500px",
                        overflowY: "scroll"
                    }}>
                    <Input.Search onChange={this.requestDocSearch} placeholder={"Type Document Name to search"} />
                    <Checkbox.Group
                        style={{
                            width: "100%"
                        }}
                        // value={this.state.requestedDocs}
                        onChange={this.onChangeRequestDocs}
                    >
                        {this.groupedDocMasterList &&
                            this.groupedDocMasterList.size ?
                            this.groupedDocMasterList.filter((obj , k) => k !=  'Progcap Others')
                                .map((_, k) => (
                                    <React.Fragment key={`${k}-item`}>
                                        <Divider
                                            orientation={"left"}
                                            key={`${k}-divider`}>
                                            {" "}
                                            {k}{" "}
                                        </Divider>

                                        <Row>
                                            {_
                                                .map(__ => (
                                                    <Col span={12} key={__.id}>
                                                        {__.document_document_type_option.length > 0 ? __.document_document_type_option.map(docOption =>  <Checkbox
                                                            className={"fb-50"}
                                                            key={docOption.id}
                                                            value={`${__.id}-${docOption.id}`}>
                                                            {docOption.document_type_name}
                                                        </Checkbox>): <Checkbox
                                                            className={"fb-50"}
                                                            key={__.id}
                                                            value={__.id}>
                                                            {__.document_name}
                                                        </Checkbox>}
                                                    </Col>
                                                ))}
                                        </Row>

                                    </React.Fragment>
                                ))
                                .toList()
                                .toArray() : null}
                    </Checkbox.Group>
                </Modal>
            </React.Fragment>
        );
    }
}

DocumentRequestModal.propTypes = {
    caseId: PropTypes.number,
    companyId: PropTypes.number,
    requestModal: PropTypes.bool,
    requestDocumentsHandler: PropTypes.func,
    closeRequestModal: PropTypes.func,
    docMasterList: PropTypes.array,
    requestDocuments: PropTypes.func,
    fetchDocumentTypes: PropTypes.func,
    docMasterListStatus: PropTypes.string
};

const mapStateToProps = (state , props) => ({
    docMasterList: state.documents.getIn(["documentsMasterList", "data"]),
    docMasterListStatus: state.documents.getIn([
        "documentsMasterList",
        "status"
    ]),
    companyDocMasterList: state.documents.getIn(["companyDocMasterList", "data"]),
    companyDocMasterListStatus :state.documents.getIn([
        "companyDocMasterList",
        "status"
    ]), 
    companyAssociates: state.companies.getIn([
        props.companyId,
        "data",
        "associates"
    ], Map({})),
    associatesStatus: state.documents.getIn([
        props.companyId,
        "status",
        "associatesStatus"
    ], STATE_STATUS.UNFETCHED),
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        requestDocuments,
        fetchDocumentTypes
    }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DocumentRequestModal);